import React from 'react';

export const ArrowUpIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m18 15-6-6-6 6" /></svg>;
export const ArrowDownIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6" /></svg>;

export const DELIVERY_TABS = [
  { id: 'new', label: 'New Pickups', match: (d) => d.deliveryStatus === 'WAITING_PICKUP' },
  { id: 'assigned', label: 'Assigned', match: (d) => d.deliveryStatus === 'ASSIGNED' },
  { id: 'picked', label: 'Picked Up', match: (d) => d.deliveryStatus === 'PICKED_UP' },
  { id: 'ofd', label: 'Out for Delivery', match: (d) => ['OUT_FOR_DELIVERY', 'ARRIVED'].includes(d.deliveryStatus) },
  { id: 'delivered', label: 'Delivered', match: (d) => d.deliveryStatus === 'DELIVERED' },
  { id: 'failed', label: 'Failed', match: (d) => d.deliveryStatus === 'FAILED' },
];

export function Stub({ title, children }) {
  return (
    <div className="rounded-3xl bg-kelate-surface shadow-[0_1px_4px_rgba(81,68,55,0.08)] p-6 text-sm text-kelate-soft" data-testid={`admin-stub-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <h3 className="text-base font-semibold text-kelate-ink">{title}</h3>
      <p className="mt-1">{children || 'Part of the KELATE roadmap. The prototype focuses on the operations-critical flows: delivery, collections, payouts and alerts.'}</p>
    </div>
  );
}
